module.exports = "/images/abs-cbn-news.png?af39577839e0c5c83bf59dc4b7c5a539";